import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { ThreeDotsLoader } from '..';
import { classes } from './ThreeDotsLoader.visual.st.css';

visualize('ThreeDotsLoader', () => {
  story('simple', () => {
    snap('default static', <ThreeDotsLoader isStatic />);
  });
  story('size variations', () => {
    snap('small (4px)', <ThreeDotsLoader isStatic className={classes.small} />);
    snap(
      'medium (8px)',
      <ThreeDotsLoader isStatic className={classes.medium} />,
    );
    snap(
      'large (16px)',
      <ThreeDotsLoader isStatic className={classes.large} />,
    );
    snap(
      'extra large (32px)',
      <ThreeDotsLoader isStatic className={classes.extraLarge} />,
    );
  });

  story('color overrides', () => {
    snap(
      'wst color override blue',
      <ThreeDotsLoader isStatic className={classes.wstColor}/>
    );
    snap(
      'tpa color override red',
      <ThreeDotsLoader isStatic className={classes.tpaColor}/>
    );
    snap(
      'tpa red overrides wst',
      <ThreeDotsLoader isStatic className={classes.bothColors}/>
    );
  });
});
